module["exports"] = [
  "com",
  "info",
  "name",
  "net",
  "org",
  "de",
  "ch"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de/internet/domain_suffix.js
 ** module id = 218
 ** module chunks = 0
 **/